import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material'

import { useGlobalStyles } from '~shared/styles/globalStyles'
import ImageLabelOverlay from '~shared/components/ImageLabelOverlay/ImageLabelOverlay'
import ServiceReportImg from '~assets/saf-ServiceReport_Collage_2500x1748px.png'
import ScreenContainerMain from '~shared/components/ScreenContainerMain'
import clsx from 'clsx'
import RoundedButton from '~shared/components/StyledButton/RoundedButton'

const ServiceReportOnline: React.FC = () => {
  const gs = useGlobalStyles()
  const { t } = useTranslation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const isTabletLarge = useMediaQuery(theme.breakpoints.down('md'))

  return <>
    <ScreenContainerMain>
      <Typography variant='h2' component='h1' className={clsx(gs.marginBottomMedium, isMobile && gs.marginLeftSmall)}>
        {t('common:serviceReportOnlinePageHeadline')}
      </Typography>
      <Grid container spacing={3} wrap='wrap-reverse'>
        <Grid item sm={12} lg={6}>
          <div>
            <Typography variant='h4' className={gs.marginBottomSmall}>
              {t('common:serviceReportOnlineTextHeadline')}
            </Typography>
            <Typography className={gs.marginBottomSmall}>{t('common:serviceReportOnlineText1')}</Typography>
            <Typography className={gs.marginBottomSmall}>{t('common:serviceReportOnlineText2')}</Typography>
            <RoundedButton
              color='secondary'
              href='http://service.safholland.de'
              target='_blank'
            >
              {t('common:startRequest')}
            </RoundedButton>
          </div>
        </Grid>
        <Grid item sm={12} lg={6} />
      </Grid>
    </ScreenContainerMain>
    <div className={clsx(gs.imageOverlay, isTabletLarge && gs.imageOverlayTablet)}>
      <div className={clsx(gs.radiusBackground, isTabletLarge && gs.radiusBackgroundTablet, !isTabletLarge && gs.biggerImage)}>
        <ImageLabelOverlay
          src={ServiceReportImg}
        />
      </div>
    </div>
  </>
}

export default ServiceReportOnline
